// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file api/v1/api.proto (package api.v1, syntax proto3)
/* eslint-disable */

import type {
  GenFile,
  GenMessage,
  GenService,
} from "@bufbuild/protobuf/codegenv1";
import {
  fileDesc,
  messageDesc,
  serviceDesc,
} from "@bufbuild/protobuf/codegenv1";
import type { EmptySchema, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import {
  file_google_protobuf_empty,
  file_google_protobuf_field_mask,
  file_google_protobuf_timestamp,
} from "@bufbuild/protobuf/wkt";
import type { IDRequestSchema, PaginationMetadata } from "./common_pb";
import { file_api_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/api.proto.
 */
export const file_api_v1_api: GenFile =
  /*@__PURE__*/
  fileDesc(
    "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",
    [
      file_google_protobuf_empty,
      file_google_protobuf_timestamp,
      file_google_protobuf_field_mask,
      file_api_v1_common,
    ],
  );

/**
 * @generated from message api.v1.Setting
 */
export type Setting = Message<"api.v1.Setting"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: bool active = 4;
   */
  active: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Setting.
 * Use `create(SettingSchema)` to create a new message.
 */
export const SettingSchema: GenMessage<Setting> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 0);

/**
 * @generated from message api.v1.ListSettingsRequest
 */
export type ListSettingsRequest = Message<"api.v1.ListSettingsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message api.v1.ListSettingsRequest.
 * Use `create(ListSettingsRequestSchema)` to create a new message.
 */
export const ListSettingsRequestSchema: GenMessage<ListSettingsRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 1);

/**
 * @generated from message api.v1.ListSettingsResponse
 */
export type ListSettingsResponse = Message<"api.v1.ListSettingsResponse"> & {
  /**
   * @generated from field: repeated api.v1.Setting settings = 1;
   */
  settings: Setting[];

  /**
   * @generated from field: api.v1.PaginationMetadata meta = 2;
   */
  meta?: PaginationMetadata;
};

/**
 * Describes the message api.v1.ListSettingsResponse.
 * Use `create(ListSettingsResponseSchema)` to create a new message.
 */
export const ListSettingsResponseSchema: GenMessage<ListSettingsResponse> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 2);

/**
 * @generated from message api.v1.UpdateSettingRequest
 */
export type UpdateSettingRequest = Message<"api.v1.UpdateSettingRequest"> & {
  /**
   * @generated from field: api.v1.Setting setting = 1;
   */
  setting?: Setting;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message api.v1.UpdateSettingRequest.
 * Use `create(UpdateSettingRequestSchema)` to create a new message.
 */
export const UpdateSettingRequestSchema: GenMessage<UpdateSettingRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 3);

/**
 * @generated from message api.v1.Deposit
 */
export type Deposit = Message<"api.v1.Deposit"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 user_id = 2;
   */
  userId: number;

  /**
   * @generated from field: double amount = 3;
   */
  amount: number;

  /**
   * @generated from field: optional bool approved = 4;
   */
  approved?: boolean;

  /**
   * @generated from field: optional string type = 5;
   */
  type?: string;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Deposit.
 * Use `create(DepositSchema)` to create a new message.
 */
export const DepositSchema: GenMessage<Deposit> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 4);

/**
 * @generated from message api.v1.DepositResponse
 */
export type DepositResponse = Message<"api.v1.DepositResponse"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 user_id = 2;
   */
  userId: number;

  /**
   * @generated from field: double amount = 3;
   */
  amount: number;

  /**
   * @generated from field: optional bool approved = 4;
   */
  approved?: boolean;

  /**
   * @generated from field: string external_id = 5;
   */
  externalId: string;

  /**
   * @generated from field: string pix_qr_code = 6;
   */
  pixQrCode: string;

  /**
   * @generated from field: string status = 7;
   */
  status: string;

  /**
   * @generated from field: optional double fee = 8;
   */
  fee?: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.DepositResponse.
 * Use `create(DepositResponseSchema)` to create a new message.
 */
export const DepositResponseSchema: GenMessage<DepositResponse> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 5);

/**
 * @generated from message api.v1.CreateDepositRequest2
 */
export type CreateDepositRequest2 = Message<"api.v1.CreateDepositRequest2"> & {
  /**
   * @generated from field: double amount = 1;
   */
  amount: number;
};

/**
 * Describes the message api.v1.CreateDepositRequest2.
 * Use `create(CreateDepositRequest2Schema)` to create a new message.
 */
export const CreateDepositRequest2Schema: GenMessage<CreateDepositRequest2> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 6);

/**
 * @generated from message api.v1.CreateDepositRequest
 */
export type CreateDepositRequest = Message<"api.v1.CreateDepositRequest"> & {
  /**
   * @generated from field: api.v1.Deposit deposit = 1;
   */
  deposit?: Deposit;
};

/**
 * Describes the message api.v1.CreateDepositRequest.
 * Use `create(CreateDepositRequestSchema)` to create a new message.
 */
export const CreateDepositRequestSchema: GenMessage<CreateDepositRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 7);

/**
 * @generated from message api.v1.ListDepositsRequest
 */
export type ListDepositsRequest = Message<"api.v1.ListDepositsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message api.v1.ListDepositsRequest.
 * Use `create(ListDepositsRequestSchema)` to create a new message.
 */
export const ListDepositsRequestSchema: GenMessage<ListDepositsRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 8);

/**
 * @generated from message api.v1.ListDepositsResponse
 */
export type ListDepositsResponse = Message<"api.v1.ListDepositsResponse"> & {
  /**
   * @generated from field: repeated api.v1.Deposit deposits = 1;
   */
  deposits: Deposit[];

  /**
   * @generated from field: api.v1.PaginationMetadata meta = 2;
   */
  meta?: PaginationMetadata;
};

/**
 * Describes the message api.v1.ListDepositsResponse.
 * Use `create(ListDepositsResponseSchema)` to create a new message.
 */
export const ListDepositsResponseSchema: GenMessage<ListDepositsResponse> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 9);

/**
 * @generated from message api.v1.Withdrawal
 */
export type Withdrawal = Message<"api.v1.Withdrawal"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 user_id = 2;
   */
  userId: number;

  /**
   * @generated from field: double amount = 3;
   */
  amount: number;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string external_id = 5;
   */
  externalId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Withdrawal.
 * Use `create(WithdrawalSchema)` to create a new message.
 */
export const WithdrawalSchema: GenMessage<Withdrawal> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 10);

/**
 * @generated from message api.v1.CreateWithdrawalRequest
 */
export type CreateWithdrawalRequest =
  Message<"api.v1.CreateWithdrawalRequest"> & {
    /**
     * @generated from field: double amount = 1;
     */
    amount: number;

    /**
     * @generated from field: optional string type = 2;
     */
    type?: string;

    /**
     * ID da chave PIX salva no nosso banco
     *
     * @generated from field: int32 pix_key_id = 3;
     */
    pixKeyId: number;
  };

/**
 * Describes the message api.v1.CreateWithdrawalRequest.
 * Use `create(CreateWithdrawalRequestSchema)` to create a new message.
 */
export const CreateWithdrawalRequestSchema: GenMessage<CreateWithdrawalRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 11);

/**
 * @generated from message api.v1.ListWithdrawalsRequest
 */
export type ListWithdrawalsRequest =
  Message<"api.v1.ListWithdrawalsRequest"> & {
    /**
     * @generated from field: int32 page = 1;
     */
    page: number;

    /**
     * @generated from field: int32 page_size = 2;
     */
    pageSize: number;
  };

/**
 * Describes the message api.v1.ListWithdrawalsRequest.
 * Use `create(ListWithdrawalsRequestSchema)` to create a new message.
 */
export const ListWithdrawalsRequestSchema: GenMessage<ListWithdrawalsRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 12);

/**
 * @generated from message api.v1.ListWithdrawalsResponse
 */
export type ListWithdrawalsResponse =
  Message<"api.v1.ListWithdrawalsResponse"> & {
    /**
     * @generated from field: repeated api.v1.Withdrawal withdrawals = 1;
     */
    withdrawals: Withdrawal[];

    /**
     * @generated from field: api.v1.PaginationMetadata meta = 2;
     */
    meta?: PaginationMetadata;
  };

/**
 * Describes the message api.v1.ListWithdrawalsResponse.
 * Use `create(ListWithdrawalsResponseSchema)` to create a new message.
 */
export const ListWithdrawalsResponseSchema: GenMessage<ListWithdrawalsResponse> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 13);

/**
 * @generated from message api.v1.PixKey
 */
export type PixKey = Message<"api.v1.PixKey"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message api.v1.PixKey.
 * Use `create(PixKeySchema)` to create a new message.
 */
export const PixKeySchema: GenMessage<PixKey> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 14);

/**
 * @generated from message api.v1.AddPixKeyRequest
 */
export type AddPixKeyRequest = Message<"api.v1.AddPixKeyRequest"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * "CPF", "CNPJ", "PHONE", "EMAIL", "RANDOM"
   *
   * @generated from field: string type = 2;
   */
  type: string;
};

/**
 * Describes the message api.v1.AddPixKeyRequest.
 * Use `create(AddPixKeyRequestSchema)` to create a new message.
 */
export const AddPixKeyRequestSchema: GenMessage<AddPixKeyRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 15);

/**
 * @generated from message api.v1.ListPixKeysRequest
 */
export type ListPixKeysRequest = Message<"api.v1.ListPixKeysRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message api.v1.ListPixKeysRequest.
 * Use `create(ListPixKeysRequestSchema)` to create a new message.
 */
export const ListPixKeysRequestSchema: GenMessage<ListPixKeysRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 16);

/**
 * @generated from message api.v1.ListPixKeysResponse
 */
export type ListPixKeysResponse = Message<"api.v1.ListPixKeysResponse"> & {
  /**
   * @generated from field: repeated api.v1.PixKey keys = 1;
   */
  keys: PixKey[];

  /**
   * @generated from field: api.v1.PaginationMetadata meta = 2;
   */
  meta?: PaginationMetadata;
};

/**
 * Describes the message api.v1.ListPixKeysResponse.
 * Use `create(ListPixKeysResponseSchema)` to create a new message.
 */
export const ListPixKeysResponseSchema: GenMessage<ListPixKeysResponse> =
  /*@__PURE__*/
  messageDesc(file_api_v1_api, 17);

/**
 * @generated from service api.v1.SettingService
 */
export const SettingService: GenService<{
  /**
   * @generated from rpc api.v1.SettingService.CreateSetting
   */
  createSetting: {
    methodKind: "unary";
    input: typeof SettingSchema;
    output: typeof SettingSchema;
  };
  /**
   * @generated from rpc api.v1.SettingService.GetSetting
   */
  getSetting: {
    methodKind: "unary";
    input: typeof IDRequestSchema;
    output: typeof SettingSchema;
  };
  /**
   * @generated from rpc api.v1.SettingService.ListSettings
   */
  listSettings: {
    methodKind: "unary";
    input: typeof ListSettingsRequestSchema;
    output: typeof ListSettingsResponseSchema;
  };
  /**
   * @generated from rpc api.v1.SettingService.UpdateSetting
   */
  updateSetting: {
    methodKind: "unary";
    input: typeof UpdateSettingRequestSchema;
    output: typeof SettingSchema;
  };
  /**
   * @generated from rpc api.v1.SettingService.DeleteSetting
   */
  deleteSetting: {
    methodKind: "unary";
    input: typeof IDRequestSchema;
    output: typeof EmptySchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_api_v1_api, 0);

/**
 * @generated from service api.v1.DepositService
 */
export const DepositService: GenService<{
  /**
   * @generated from rpc api.v1.DepositService.CreateDeposit
   */
  createDeposit: {
    methodKind: "unary";
    input: typeof CreateDepositRequestSchema;
    output: typeof DepositResponseSchema;
  };
  /**
   * @generated from rpc api.v1.DepositService.ListDeposits
   */
  listDeposits: {
    methodKind: "unary";
    input: typeof ListDepositsRequestSchema;
    output: typeof ListDepositsResponseSchema;
  };
  /**
   * @generated from rpc api.v1.DepositService.ListDepositsAdm
   */
  listDepositsAdm: {
    methodKind: "unary";
    input: typeof ListDepositsRequestSchema;
    output: typeof ListDepositsResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_api_v1_api, 1);

/**
 * @generated from service api.v1.WithdrawalService
 */
export const WithdrawalService: GenService<{
  /**
   * @generated from rpc api.v1.WithdrawalService.CreateWithdrawal
   */
  createWithdrawal: {
    methodKind: "unary";
    input: typeof CreateWithdrawalRequestSchema;
    output: typeof WithdrawalSchema;
  };
  /**
   * @generated from rpc api.v1.WithdrawalService.ListWithdrawals
   */
  listWithdrawals: {
    methodKind: "unary";
    input: typeof ListWithdrawalsRequestSchema;
    output: typeof ListWithdrawalsResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_api_v1_api, 2);

/**
 * @generated from service api.v1.PixKeyService
 */
export const PixKeyService: GenService<{
  /**
   * @generated from rpc api.v1.PixKeyService.AddPixKey
   */
  addPixKey: {
    methodKind: "unary";
    input: typeof AddPixKeyRequestSchema;
    output: typeof PixKeySchema;
  };
  /**
   * @generated from rpc api.v1.PixKeyService.ListPixKeys
   */
  listPixKeys: {
    methodKind: "unary";
    input: typeof ListPixKeysRequestSchema;
    output: typeof ListPixKeysResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_api_v1_api, 3);
